// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__znz3x","author":"Table_author__3ahQF","authorImage":"Table_authorImage__OF1Bv","unreadRow":"Table_unreadRow__2WDsU"};